// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sPfS","colMin":"styles_colMin__2s1Gz"};